<cerrix-loader [cerrixTab]="tab"></cerrix-loader>
@if (model) {
    <div class="detail-page-action-bar flex-action-bar">
        <div>
            <button data-uiid="button-savetaskseries" class="btn btn-cerrix" (click)="save()">
                <i class="fas fa-save"></i>
                <span class="d-none d-lg-inline">{{ 'tasks.save' | transloco }}</span>
            </button>

            <span class="date-edited"> {{ 'tasks.lastSave' | transloco: { dateModified: (model.dateModified | dateTimeFormat) } }} </span>
        </div>
    </div>

    <div
        class="task-series-screen-system"
        menuSystem
        [cerrixTab]="tab"
        (changeEvent)="handleMenuItemClick($event)"
    >
        <div
            class="task-series-screens"
            [attr.name]="'tasks.taskSeries' | transloco"
            menuicon="fa-fw fa-tasks far"
            menusystemsubmenu
        >
            <div
                menuItemId="menuDetails"
                [attr.name]="'tasks.details' | transloco"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <task-series-detail-main
                    [(model)]="model"
                    [cerrixTab]="tab"
                    [permissions]="permissions"
                    #detailMain
                >
                </task-series-detail-main>
            </div>
            @if (id) {
                @if (isInitialized && permissions) {
                    <div
                        class="task-series-screens"
                        [attr.menuItemId]="'menuLinks'"
                        [attr.name]="'tasks.links' | transloco"
                        menuicon="fas fa-link"
                        menusystemsubmenu
                    >
                        <div
                            menuItemId="menuItemTasks"
                            [attr.name]="'tasks.tasks' | transloco"
                            menuicon="fa-fw fa-tasks far"
                            menusystemitem
                        >
                            <generic-pagination-list-manager
                                [config]="this.tasksConfig"
                            ></generic-pagination-list-manager>
                        </div>
                        @if (model.linkedTypes.includes(taskType.ControlExecution)) {
                            <div
                                menuItemId="menuItemControls"
                                [attr.name]="'tasks.controls' | transloco"
                                menuicon="fas fa-shield-alt"
                                menusystemitem
                            >
                                <!-- control linking disabled for now -->
                                <task-series-controls
                                    [(model)]="model"
                                    [disabled]="true || !permissions.CanEdit"
                                    #taskseriescontrols
                                ></task-series-controls>
                            </div>
                        }
                        <div
                            menuItemId="menuItemDocuments"
                            [attr.name]="'tasks.documents' | transloco"
                            menuicon="far fa-file"
                            menusystemitem
                        >
                            @if (documents) {
                                <div>
                                    <!-- AllowEdit is set to false to prevent problems with replacing a changed file in the related task and control execution documents.
                                    The way it is implemented causes the task and control execution document to be deleted because these have an DocumentId
                                    that does not match the document id of the task series -->
                                    <document-manager-old
                                        [(Documents)]="model.Documents"
                                        (DocumentsChange)="checkDocumentsDirty()"
                                        [permissions]="permissions.documentPermissions"
                                        [AllowEdit]="false"
                                        [DocumentTypeTargets]="targetModule"
                                    >
                                    </document-manager-old>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                        <div
                            menuItemId="menuItemHyperlinks"
                            [attr.name]="'tasks.hyperlinks' | transloco"
                            menuicon="fas fa-external-link-alt"
                            menusystemitem
                        >
                            @if (model.Hyperlinks) {
                                <div>
                                    <hyperlink-manager
                                        [(Hyperlinks)]="model.Hyperlinks"
                                        (HyperlinksChanged)="checkHyperlinksDirty($event)"
                                        [TargetModule]="targetModule"
                                    ></hyperlink-manager>
                                </div>
                            } @else {
                                <div>
                                    <div class="fancy-loader"></div>
                                </div>
                            }
                        </div>
                    </div>
                }

                <div menuItemId="Options" [attr.name]="'tasks.options' | transloco" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="task serie"
                        [objectName]="model ? model.name : 'task serie'"
                        [allowDelete]="permissions.canDelete"
                        customText='Are you sure you want to delete the task series? Tasks marked "Done" will be removed as well.'
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
